/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationStrictHttpResponse } from '../../authentication-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SocialAccountModel } from '../../models/social-account-model';
import { UnlinkSocialAccountRequestModel } from '../../models/unlink-social-account-request-model';

export interface LocalAccountUnlinkAccountPost$Params {
  
    /**
     * Unlink social account request model containing issuer information
     */
    body?: UnlinkSocialAccountRequestModel
}

export function localAccountUnlinkAccountPost(http: HttpClient, rootUrl: string, params?: LocalAccountUnlinkAccountPost$Params, context?: HttpContext): Observable<AuthenticationStrictHttpResponse<Array<SocialAccountModel>>> {
  const rb = new RequestBuilder(rootUrl, localAccountUnlinkAccountPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthenticationStrictHttpResponse<Array<SocialAccountModel>>;
    })
  );
}

localAccountUnlinkAccountPost.PATH = '/LocalAccount/UnlinkAccount';
